import { useContext } from 'react';
import { useRecoilValue } from 'recoil';
import { DataContext } from 'entries/common/widgets/context';
import { useToggleProjectStatus } from 'pages/common/hooks/use-toggle-project-saving';
import { userProjectConfigurationCookieNames } from 'pages/project-configuration/const';
import { complimentaryProductsState, useCalculationState } from 'pages/calculation/store/calculation';
import { dimensionsAtom } from 'pages/dimensions/store/dimensions';
import { getCookie } from 'utils/cookie.helper';
import { configurateGeneralItems } from '../helpers/configurate-general-items.helper';

export const useToggleCalculationProjectStatus = () => {
  const { calculationFormState, totalAmount } = useCalculationState();
  const complimentaryProducts = useRecoilValue(complimentaryProductsState);
  const dimensions = useRecoilValue(dimensionsAtom);
  const configurationId = getCookie(userProjectConfigurationCookieNames.LAMINATE) ?? '';
  const data = useContext(DataContext);

  const generalItems = configurateGeneralItems({
    data,
    dimensions,
    complimentaryProducts,
    count: Number(calculationFormState.count),
  });

  const { isProjectSaved, saveProject, unsaveProject } = useToggleProjectStatus({
    api: data!.api,
    configurationId,
    regionId: data?.regionId,
    totalAmount,
    generalItems,
    isOpenFromProject: false,
  });

  return {
    isProjectSaved,
    saveProjectToShoppingList: saveProject,
    removeProjectFromShoppingList: unsaveProject,
  };
};
